import React, { useMemo, useState } from 'react'
import { Breadcrumbs, InsideFooter, Loading } from '../../../components'
import ErrorMessage from '../../../components/Form/ErrorMessage'
import { PaginationOrder } from '../../../constants/pagination'
import useHistory from '../../../hooks/useHistory'
import { BoxContainer, BoxBrand } from '../../Admin/Companies/Brands/styles'
import { Container, Top } from '../../Admin/styles'
import { DefaultAdminPage } from '../../DefaultPages'
import { usePendingApprovalAnswersQuery } from './hooks'

const Review = () => {
  const history = useHistory()
  const [error, setError] = useState('')
  const [searchParameters, _setSearchParameters] = useState({
    order: PaginationOrder.ASC
  })

  const {
    data: pendingApproval,
    isFetching,
    isLoading
  } = usePendingApprovalAnswersQuery(searchParameters, setError)

  // Gera a lista de lojas com base no array pendingApproval
  const { data: brands } = useMemo(() => {
    const brandsRepeated = pendingApproval?.map(
      ({ certificate }) => certificate.brand
    )
    const brandsUnique = brandsRepeated?.reduce((acc, brand) => {
      if (!acc.find((b) => b.id === brand.id)) {
        acc.push(brand)
      }
      return acc
    }, [])

    return {
      data: brandsUnique
    }
  }, [pendingApproval])

  const handleClickBrand = (brandId) => {
    history.push(`/admin/review/${brandId}/certificates`)
  }

  return (
    <DefaultAdminPage page="revisao">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <h3>
          Aqui você encontra todas as lojas com respostas pendentes de
          aprovação.
        </h3>
        <BoxContainer>
          {isLoading && <Loading />}
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {!isLoading && !isFetching && !brands.length && (
            <p>Nenhuma resposta pendente de aprovação.</p>
          )}
          {brands?.map?.((brand) => (
            <BoxBrand key={brand.id} onClick={() => handleClickBrand(brand.id)}>
              <h3>{brand.brandName}</h3>
              <p>{brand.urlWebsite}</p>
            </BoxBrand>
          ))}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default Review
